import { apiClient } from '../../core/api';

/** Public media id + absolute URL returned by the editor image upload. */
export interface MediaUploadResponse {
  id: string;
  url: string;
}

/**
 * Upload a local image from the draft editor. The backend stores it in the
 * tenant-isolated public media bucket and returns an absolute, Shopify-fetchable
 * URL ({@link MediaUploadResponse.url}) to drop straight into the draft's HTML.
 */
export async function uploadEditorImage(
  userId: string,
  file: File
): Promise<MediaUploadResponse> {
  const formData = new FormData();
  formData.append('file', file, file.name || 'image');
  const res = await apiClient.post<MediaUploadResponse>(`/media/${userId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}
